import { ActionsHook } from "@/lib/Components/Actions/ActionGroupButtons";
import { ChatBubbleLeftIcon, CheckIcon } from "@heroicons/react/20/solid";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { BookingChangeRequestApproveDialog } from "@/app/Bookings/Components/Dialogs/BookingChangeRequestApproveDialog";
import { BookingChangeRequestStatus, ModelType } from "@/gql/graphql";
import { BookingChangeRequestListItem } from "@/app/Bookings/GraphQL/bookingChangeRequestListQuery";
import { ActivityIcon } from "lucide-react";
import { ActivityLogDialog } from "@/app/ActivityLogs/Components/ActivityLogDialog";
import { BookingChangeRequestActionedDialog } from "@/app/Bookings/Components/Dialogs/BookingChangeRequestActionedDialog";

export function useBookingChangeRequestActions(): ActionsHook<BookingChangeRequestListItem> {
  const { open } = useDialog(BookingChangeRequestApproveDialog);
  const { open: openActionedDialog } = useDialog(
    BookingChangeRequestActionedDialog,
  );
  const { open: openActivityLog } = useDialog(ActivityLogDialog);

  return (model) => {
    return [
      {
        label: "Actions",
        items: [
          {
            actions: [
              {
                label: "Mark actioned",
                Icon: ChatBubbleLeftIcon,
                color: "indigo",
                isHidden: model.status !== BookingChangeRequestStatus.Pending,
                handleAction: () => {
                  openActionedDialog({
                    changeRequest: model,
                  });
                },
              },
            ],
          },
          {
            actions: [
              {
                label: "Accept",
                Icon: CheckIcon,
                color: "green",
                isHidden: ![
                  BookingChangeRequestStatus.Pending,
                  BookingChangeRequestStatus.Actioned,
                ].includes(model.status),
                handleAction: () => {
                  open({
                    changeRequest: model,
                    type: "approve",
                  });
                },
              },
              {
                label: "Decline",
                isHidden: ![
                  BookingChangeRequestStatus.Pending,
                  BookingChangeRequestStatus.Actioned,
                ].includes(model.status),
                Icon: XMarkIcon,
                color: "red",
                handleAction: () => {
                  open({
                    changeRequest: model,
                    type: "reject",
                  });
                },
              },
            ],
          },
          {
            actions: [
              {
                label: "Activity",
                Icon: ActivityIcon,
                handleAction: () => {
                  openActivityLog({
                    modelId: model.booking.id,
                    modelType: ModelType.Booking,
                  });
                },
              },
            ],
          },
        ],
      },
    ];
  };
}
